var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 34,
    fill: "#97191B",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#97191B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.408 34.0002L39.708 29.7102C39.8963 29.5219 40.0021 29.2665 40.0021 29.0002C40.0021 28.7339 39.8963 28.4785 39.708 28.2902C39.5197 28.1019 39.2643 27.9961 38.998 27.9961C38.7317 27.9961 38.4763 28.1019 38.288 28.2902L33.998 32.5902L29.708 28.2902C29.5197 28.1019 29.2643 27.9961 28.998 27.9961C28.7317 27.9961 28.4763 28.1019 28.288 28.2902C28.0997 28.4785 27.9939 28.7339 27.9939 29.0002C27.9939 29.2665 28.0997 29.5219 28.288 29.7102L32.588 34.0002L28.288 38.2902C28.1943 38.3831 28.1199 38.4937 28.0691 38.6156C28.0183 38.7375 27.9922 38.8682 27.9922 39.0002C27.9922 39.1322 28.0183 39.2629 28.0691 39.3848C28.1199 39.5066 28.1943 39.6172 28.288 39.7102C28.3809 39.8039 28.4915 39.8783 28.6134 39.9291C28.7353 39.9798 28.866 40.006 28.998 40.006C29.13 40.006 29.2607 39.9798 29.3826 39.9291C29.5044 39.8783 29.615 39.8039 29.708 39.7102L33.998 35.4102L38.288 39.7102C38.3809 39.8039 38.4915 39.8783 38.6134 39.9291C38.7353 39.9798 38.866 40.006 38.998 40.006C39.13 40.006 39.2607 39.9798 39.3826 39.9291C39.5044 39.8783 39.615 39.8039 39.708 39.7102C39.8017 39.6172 39.8761 39.5066 39.9269 39.3848C39.9776 39.2629 40.0038 39.1322 40.0038 39.0002C40.0038 38.8682 39.9776 38.7375 39.9269 38.6156C39.8761 38.4937 39.8017 38.3831 39.708 38.2902L35.408 34.0002Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/fail.ee2f9d356cc18d879109f978b1eda0b3.svg";
export { ForwardRef as ReactComponent };